const $tgFeed = document.querySelector('.js-tg-feed')

if ($tgFeed !== null) {
	fetch('https://sheets.googleapis.com/v4/spreadsheets/1LW72H2IySg-WlGOhReHzH0K0J2rei1gm1lLqlLJCvwI/?key=AIzaSyDxNGIuNpXX7_81JBgyVF2zzEKlhVlVCns&includeGridData=true')
		.then(response => response.json())
		.then(function (response) {
			const arIds = []
			try {
				if (response) {
					response.sheets[0].data[0].rowData.forEach(row => {
						if (row.hasOwnProperty('values')) {
							if (row.values[0].hasOwnProperty('userEnteredValue')) {
								const str = row.values[0].userEnteredValue.stringValue
								arIds.push(str.substr(str.lastIndexOf('/') + 1))
							}
						}
					});
				}
			} catch (error) {
				console.log(error)    
			}
	
			return arIds
		})
		.then(function (arIds) {
			arIds.reverse().forEach(function(id) {
				let post = document.createElement('div')
				let script = document.createElement('script')

				script.setAttribute('async', true)
				script.setAttribute('src', 'https://telegram.org/js/telegram-widget.js?12')
				script.setAttribute('data-telegram-post', `feed3h/${id}`)
				script.setAttribute('data-width', `100%`)
				post.classList.add('tg-feed__post')
				post.appendChild(script)

				$tgFeed.appendChild(post)
			})
		})
		.catch(function (error) {
			console.log(error)
		});
}



// WEBPACK FOOTER //
// ./temp/components/feed/.variant/base/index.js